import { environment } from '../../environments/environment';

/**
 * Monta URL do microserviço de agenda no formato Azure Functions:
 * `{base}/{resource}?code={scheduleFunctionKey}` quando for host direto (azurewebsites).
 * Em APIM (`azure-api.net`) não anexa `code`.
 */
export function buildScheduleApiUrl(resource: string, query?: Record<string, string | number | undefined | null>): string {
  const raw = (environment.microservices.schedule || '').trim();
  const [basePart] = raw.split('?');
  let base = basePart.replace(/\/$/, '');

  const isApim = /azure-api\.net/i.test(base);
  if (isApim && !/\/api$/i.test(base)) {
    base = `${base}/api`;
  }

  const res = resource.replace(/^\//, '');
  let path = `${base}/${res}`;

  const params = new URLSearchParams();
  if (query) {
    for (const [key, value] of Object.entries(query)) {
      if (value === undefined || value === null || value === '') continue;
      params.set(key, String(value));
    }
  }

  const code = ((environment as { scheduleFunctionKey?: string }).scheduleFunctionKey || '').trim();
  if (code && !isApim && !params.has('code')) {
    params.set('code', code);
  }

  const qs = params.toString();
  return qs ? `${path}?${qs}` : path;
}
